var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToshipadLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1691,
    height: 260,
    viewBox: "0 0 1691 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M712.536 75.3816H644.698V204.205H627.477V75.3816H559.843V59.6873H712.536V75.3816Z",
    fill: "url(#paint0_linear_4917_1077)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M703.71 148.044C703.71 110.885 728.925 87.3435 771.547 87.3435C814.169 87.3435 839.384 110.885 839.384 148.044C839.384 185.204 814.169 208.524 771.547 208.524C728.925 208.524 703.71 185.204 703.71 148.044ZM822.383 148.044C822.383 117.49 800.649 102.425 771.547 102.425C742.445 102.425 720.711 117.49 720.711 148.044C720.711 178.395 742.445 193.459 771.547 193.459C800.666 193.459 822.383 178.395 822.383 148.044Z",
    fill: "url(#paint1_linear_4917_1077)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M983.902 171.994C983.902 192.234 963.605 208.541 925.495 208.541C899.874 208.541 877.532 199.655 860.311 184.387L870.975 174.275C885.526 186.668 902.544 194.498 925.901 194.498C949.071 194.498 967.306 187.28 967.306 173.646C967.306 159.602 950.71 155.892 922.216 153.406C892.709 150.938 864.621 144.538 864.621 121.405C864.621 99.3101 889.21 87.3435 922.216 87.3435C944.761 87.3435 965.869 96.4333 978.173 106.544L967.509 117.898C957.064 108.808 942.091 101.591 921.388 101.387C904.37 101.182 881.217 105.302 881.217 120.383C881.217 134.427 901.311 137.099 925.698 138.972C959.295 141.644 983.902 150.104 983.902 171.994Z",
    fill: "url(#paint2_linear_4917_1077)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1134.54 140.602V204.18H1117.73V141.827C1117.73 116.43 1105.22 102.609 1080.02 102.609C1058.31 102.609 1040.26 112.72 1030.02 133.572V204.18H1013.2V51.406H1030.02V114.984C1040.46 98.0466 1059.32 87.5269 1083.3 87.5269C1117.93 87.544 1134.54 109.843 1134.54 140.602Z",
    fill: "url(#paint3_linear_4917_1077)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1171.87 63.3669C1171.87 57.1708 1176.99 52.4216 1183.77 52.4216C1190.53 52.4216 1195.65 57.1708 1195.65 63.3669C1195.65 69.3586 1190.53 74.3121 1183.77 74.3121C1176.99 74.3121 1171.87 69.3416 1171.87 63.3669ZM1192.17 204.157H1175.35V91.6406H1192.17V204.157Z",
    fill: "url(#paint4_linear_4917_1077)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1387.68 105.511C1387.68 134.414 1365.75 151.334 1332.76 151.334H1254.06V204.188H1236.83V59.6873H1332.76C1365.75 59.6873 1387.68 76.6072 1387.68 105.511ZM1370.06 105.511C1370.06 85.2715 1354.9 75.7902 1331.53 75.7902H1254.06V135.248H1331.53C1354.9 135.231 1370.06 125.733 1370.06 105.511Z",
    fill: "url(#paint5_linear_4917_1077)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1529.94 141.817V182.278C1529.94 190.738 1531.38 197.547 1535.26 204.152H1517.43C1514.16 198.586 1512.72 192.594 1512.72 186.194V185.785C1503.91 197.973 1486.29 208.288 1462.09 208.288C1437.7 208.288 1405.12 198.381 1405.12 168.439C1405.12 138.719 1437.7 128.591 1462.09 128.591C1486.27 128.591 1503.9 138.702 1512.72 151.094V141.8C1512.72 114.547 1497.36 102.155 1466.6 102.155C1448.77 102.155 1435.23 107.109 1422.74 115.16L1414.95 102.768C1428.07 93.8826 1449.17 87.4993 1469.47 87.4993C1506.99 87.5333 1529.94 106.104 1529.94 141.817ZM1513.13 166.397C1503.49 148.847 1482.38 142.651 1463.52 142.651C1447.13 142.651 1421.71 147.4 1421.71 168.456C1421.71 189.513 1447.13 194.262 1463.52 194.262C1482.38 194.262 1503.49 187.862 1513.13 170.516V166.397Z",
    fill: "url(#paint6_linear_4917_1077)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1673.21 113.349V51.406H1690.03V204.18H1673.21V182.51C1662.97 198.205 1643.91 208.316 1619.3 208.316C1582 208.316 1558.63 184.366 1558.63 148.041C1558.63 111.715 1582 87.561 1619.3 87.561C1643.91 87.544 1662.97 97.6551 1673.21 113.349ZM1673.21 165.778V130.065C1661.74 110.047 1644.31 102.609 1623.61 102.609C1592.87 102.609 1575.65 118.916 1575.65 148.024C1575.65 176.927 1592.87 193.234 1623.61 193.234C1644.31 193.234 1661.74 185.813 1673.21 165.778Z",
    fill: "url(#paint7_linear_4917_1077)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M415.955 0H332.773V60.003H415.955V0Z",
    fill: "url(#paint8_linear_4917_1077)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M399.326 0H332.773V60.003H399.326V0Z",
    fill: "url(#paint9_linear_4917_1077)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M382.679 0H332.773V60.003H382.679V0Z",
    fill: "url(#paint10_linear_4917_1077)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M366.049 0H332.773V60.003H366.049V0Z",
    fill: "url(#paint11_linear_4917_1077)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M349.384 0H331.757V60.003H349.384V0Z",
    fill: "url(#paint12_linear_4917_1077)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M332.747 0H0V60.003H332.747V0Z",
    fill: "url(#paint13_linear_4917_1077)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M277.991 59.9998C277.991 88.8522 211.877 112.632 158.76 131.748C123.253 144.515 86.5288 157.724 57.9844 174.848C19.5028 197.913 0 226.561 0 259.993H59.573C59.573 231.14 125.686 207.36 178.804 188.244C214.311 175.478 251.035 162.269 279.579 145.144C307.025 128.701 324.804 109.398 332.747 87.5586L277.991 59.9998Z",
    fill: "url(#paint14_linear_4917_1077)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4917_1077",
    x1: 636.189,
    y1: 59.6873,
    x2: 636.189,
    y2: 204.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4917_1077",
    x1: 771.547,
    y1: 87.3435,
    x2: 771.547,
    y2: 208.524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4917_1077",
    x1: 922.106,
    y1: 87.3435,
    x2: 922.106,
    y2: 208.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4917_1077",
    x1: 1073.87,
    y1: 51.406,
    x2: 1073.87,
    y2: 204.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4917_1077",
    x1: 1183.76,
    y1: 52.4216,
    x2: 1183.76,
    y2: 204.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4917_1077",
    x1: 1312.26,
    y1: 59.6873,
    x2: 1312.26,
    y2: 204.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4917_1077",
    x1: 1470.19,
    y1: 87.4993,
    x2: 1470.19,
    y2: 208.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4917_1077",
    x1: 1624.33,
    y1: 51.406,
    x2: 1624.33,
    y2: 208.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4917_1077",
    x1: 374.364,
    y1: 0,
    x2: 374.364,
    y2: 60.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4917_1077",
    x1: 366.049,
    y1: 0,
    x2: 366.049,
    y2: 60.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4917_1077",
    x1: 357.726,
    y1: 0,
    x2: 357.726,
    y2: 60.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4917_1077",
    x1: 349.411,
    y1: 0,
    x2: 349.411,
    y2: 60.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4917_1077",
    x1: 340.571,
    y1: 0,
    x2: 340.571,
    y2: 60.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4917_1077",
    x1: 166.374,
    y1: 0,
    x2: 166.374,
    y2: 60.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4917_1077",
    x1: 166.374,
    y1: 59.9998,
    x2: 166.374,
    y2: 259.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToshipadLogo);
export default __webpack_public_path__ + "static/media/toshipadLogo.a18c98feca51cfcef0a691c5f9002553.svg";
export { ForwardRef as ReactComponent };